'use strict';

import { flow, observable, configure, action, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import {States} from "./AppConstants";
import appStore from './AppStore';

class BackdoorStore {
    state = States.initial;
    formData = {};
    errorMessage = null;

    constructor() {
        makeObservable(this, {
            state: observable,
            formData: observable,
            errorMessage: observable,
            updateFormValue: action,
            clearError: action
        });
    }

    updateFormValue(newValue) {
        this.formData.backdoor = newValue;
    }

    clearError() {
        this.errorMessage = null;
    }

    submitBackdoor = flow(function* () {
        let backdoorId = this.formData.backdoor;

        this.state = States.pending;
        try {
            yield appStore.getHttpClient().doPost(`api/backdoor`, {userName: backdoorId}, "start backdoor");
            // If the response was successful, we'll refresh the page and pull down the modified session on boot
            appStore.doRefresh();
            this.state = States.done;
        }
        catch (error) {
            this.errorMessage = error.message;
            this.state = States.error;
            return;
        }

    });
}

export default BackdoorStore;
